module.exports = __webpack_public_path__ + "media/images/fpx-432dd8fa9426bfae3d7852d1dbaa72c3.png";